<template>
<div class="no-scroll-content" >
    <!-- <vx-card class="no-scroll-content" title="List of Filed Leaves" > -->

        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <!-- <vs-button type="gradient" @click="promptAddNewLeave()" icon-pack="feather" icon="icon-file">Apply Leave</vs-button> -->
        <vs-table stripe max-items="12" pagination v-model="selected"  search  :data="getEmployeeLeaveRequests">

            <template slot="thead">
                <vs-th sort-key="createdOn">Date Applied</vs-th>
                <vs-th sort-key="leaveTypeId">Leave Type</vs-th>
                 <vs-th sort-key="leaveTypeId">Leave Balance</vs-th>
                <vs-th sort-key="fromDate">From Date</vs-th>
                <vs-th>To Date</vs-th>
                <vs-th>No Of Days</vs-th>
                <vs-th>Reason</vs-th>
                <vs-th>Employee</vs-th>
                <vs-th><vs-icon  color="primary" icon-pack="feather" icon="icon-paperclip"  /></vs-th>
                <vs-th>Status</vs-th>
                <vs-th>Remarks</vs-th>
                <vs-th>Actions</vs-th>
            </template>

            <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].createdOn">
                            {{data[indextr].createdOn | fulldate}}
                        </vs-td>
                        <vs-td :data="data[indextr].leaveTypeId">
                            {{  data[indextr].leaveType.leaveTypeName }}
                        </vs-td>
                        <vs-td :data="data[indextr].leaveTypeId">
                            {{  checkLeaveBalance(data[indextr]) }}
                        </vs-td>
                        <vs-td :data="data[indextr].fromDate">
                            {{data[indextr].fromDate | fulldate}}
                        </vs-td>
                        <vs-td :data="data[indextr].toDate">
                            {{data[indextr].toDate | fulldate }}
                        </vs-td>
                        <vs-td :data="data[indextr].noOfDays">
                            {{data[indextr].noOfDays}}
                        </vs-td>
                        <vs-td :data="data[indextr].reason">
                            {{data[indextr].reason}}
                        </vs-td>
                        <!-- <vs-td >
                            <ul class="users-liked user-list">
                                <li :key="indextd" v-for="(user, indextd) in data[indextr].approversLMs">
                                   
                                    <vx-tooltip :text="user.approver.fullName">
                                        <vs-avatar v-if="user.approver.photoUrl != ''" class="border-2 border-white border-solid -m-1" size="30px" :src="user.approver.photoUrl" />
                                        <vs-avatar v-else class="border-2 border-white border-solid -m-1" size="30px" :text="user.approver.fullName" :color="user.approver.firstName.length <= 3 ? 'success' : user.approver.firstName.length < 6 ? 'primary' : user.approver.firstName.length < 8 ? 'warning' : user.approver.firstName.length < 10 ? 'danger' : user.approver.firstName.length < 13 ? 'dark' : user.approver.firstName.length < 15? 'success' : 'hex'"/>
                                    </vx-tooltip>
                                </li>
                            </ul>
                        </vs-td> -->
                        <vs-td :data="data[indextr].user.photoUrl">
                            <vx-tooltip v-bind:text="data[indextr].user.fullName">
                                <!-- <vs-avatar class="rounded-full shadow-md cursor-pointer block" size="medium" :src="data[indextr].user.photoUrl" /> -->
                                <vs-avatar v-if="data[indextr].user.photoUrl != ''" class="border-2 border-white border-solid -m-1" size="30px" :src="user.approver.photoUrl" />
                                <vs-avatar v-else class="border-2 border-white border-solid -m-1" size="30px" :text="data[indextr].user.fullName" :color="data[indextr].user.fullName.length < 12 ? 'success' : data[indextr].user.fullName.length <= 15 ? 'primary' : data[indextr].user.fullName.length <= 20 ? 'warning' : 'danger'"/>
                                    
                            </vx-tooltip>
                        </vs-td>
                        <vs-td  :data="data[indextr].fileId" >
                            <vs-icon v-show="data[indextr].fileId != [] && data[indextr].fileId != null" @click="downloadFile(data[indextr].fileId)"  color="primary" icon-pack="feather" icon="icon-paperclip"  />
                        </vs-td>
                        <vs-td :data="data[indextr].fileId">
                                <span class="flex items-center px-2 py-1 rounded">
                                    <div  :class="onGetStatus(data[indextr]) == 'Approved' ? 'h-3 w-3 rounded-full mr-2 bg-success' : 
                                        onGetStatus(data[indextr]) == 'Partially Approved' ? 'h-3 w-3 rounded-full mr-2 bg-partial' :
                                        onGetStatus(data[indextr]) == 'For Revision' ? 'h-3 w-3 rounded-full mr-2 bg-primary' :
                                        onGetStatus(data[indextr]) == 'Retracted' ? 'h-3 w-3 rounded-full mr-2 bg-dark' :
                                        onGetStatus(data[indextr]) == 'Denied' ? 'h-3 w-3 rounded-full mr-2 bg-danger' :
                                        onGetStatus(data[indextr]) == 'Draft' ? 'h-3 w-3 rounded-full mr-2 bg-draft' :
                                        onGetStatus(data[indextr]) == 'For Approval' ? 'h-3 w-3 rounded-full mr-2 bg-warning' : 'h-3 w-3 rounded-full mr-2 bg-danger'"/>
                                        {{onGetStatus(data[indextr])}}
                                    
                                </span>
                        </vs-td>
                        <vs-td >
                            <!-- <span :data="item" :key="index" v-for="(item, index) in data[indextr].approversLMs"> -->
                            <span>
                                {{ data[indextr].remarks}}
                            </span>
                        </vs-td>
                        <vs-td >
                            <div class="vx-row">
                                <div class="flex">
                                    <vx-tooltip :text="onCheckPriority(data[indextr], onGetStatus(data[indextr])) ? 'Approve' : ''">
                                        <feather-icon v-show="onCheckPriority(data[indextr], onGetStatus(data[indextr]))" icon="CheckIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="onApproved(data[indextr].employeeFiledLeaveId)" />
                                    </vx-tooltip>
                                </div>
                                <div class="flex">
                                    <vx-tooltip :text="onCheckPriority(data[indextr], onGetStatus(data[indextr])) ? 'Deny' : ''">
                                        <feather-icon v-show="onCheckPriority(data[indextr], onGetStatus(data[indextr]))" icon="XIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="onDenied(data[indextr].employeeFiledLeaveId)" />
                                    </vx-tooltip>
                                </div>
                                 <div class="flex">
                                    <vx-tooltip :text="onCheckPriority(data[indextr], onGetStatus(data[indextr]))? 'Ask to Revise' : ''">
                                        <feather-icon v-show="onCheckPriority(data[indextr], onGetStatus(data[indextr]))" icon="RepeatIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="onForRevision(data[indextr].employeeFiledLeaveId)" />
                                    </vx-tooltip>
                                </div>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
        </vs-table>


        
</div>  
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moduleLeaveManagement from '@/store/leavemanagement/moduleLeaveManagement.js'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Swal from 'sweetalert2'
export default {
    data() {
        return {
            selected: [],
            employeeFiledLeaveId: null,

            remarks: '',

            activeDeniedDialog: false,
            activeRevisionDialog: false,

            userLeaveBalance: [],
        }
    },
    created() {
        this.$store.registerModule('leavemanagement', moduleLeaveManagement)
        const payload = {
                sortBy: 'CreatedOn',
                sortOrder: 'Desc',
                pageNumber: 1,
                pageSize: -1,
                isApprover: true
            }
                this.$store.dispatch('leavemanagement/getAllLeaves', payload)
        this.$store.dispatch('lookup/getAllLeaveTypeLookup')
        // this.$store.dispatch('hrms/getAllLeaveBenefits', this.$store.state.AppActiveUser.uid)
        

    },
    beforeDestroy () {
        this.$store.unregisterModule('leavemanagement')
    }, 
    computed: {
        getEmployeeLeaveRequests() {
            return this.$store.state.leavemanagement.employeeFiledLeaves
        },
        onGetStatus() {
             return (data) => {
                var leaveStatus = ''
                var c = data.approversLMs.length
                data.approversLMs.forEach((a) => {
                    if(a.isApproved && a.priorityId == 1){
                        if(c > 1) {
                            leaveStatus = 'Partially Approved'
                        }
                        else
                            leaveStatus = 'Approved'
                    } 
                    else if(a.isApproved && a.priorityId == 2){
                        if(c > 2) {
                            leaveStatus = 'Partially Approved'
                        }
                        else
                            leaveStatus = 'Approved'
                    }else if (data.isCancelled) {
                        leaveStatus = 'Cancelled'
                    } else if(a.isRevised) { 
                        leaveStatus = 'For Revision'      
                    }else if(a.isDenied) { 
                        leaveStatus = 'Denied'
                    }else if(data.isRetracted) { 
                        leaveStatus = 'Retracted'
                    }else if (data.isDraft) {
                        leaveStatus = 'Draft'
                    }else if (data.isSubmitted && leaveStatus == '') {
                        leaveStatus = 'For Approval'
                    }
                    
                    // if(a.approverId == this.$store.state.AppActiveUser.uid)
                    // this.priorityId = a.priorityId
                })
                return leaveStatus
             }
        },
        onCheckPriority() {
            return (approvers, status) => {
                var s = false
                var priorityId = 0
                approvers.approversLMs.forEach(a => {
                    if(a.approverId == this.$store.state.AppActiveUser.uid)
                        priorityId =  a.priorityId
                })
                
                switch(priorityId){
                    case 1:
                        if(status === 'For Approval')
                            s = true
                        else
                            s = false
                        break;
                    case 2:
                    case 3:
                        if(status === 'Partially Approved')
                            s = true
                        else
                            s = false
                        break;
                }
                return s
            }
            
             
        },
        getCurrentDate() {
            return moment(new Date()).utc().format("YYYY-MM-DD")
        },
        approverName() {
            return  this.$store.getters['leavemanagement/approverName'](this.$store.state.AppActiveUser.uid) 
        },
        leaveType() {
             return (leaveTypeId) => this.$store.getters['lookup/leaveTypeLookup'](leaveTypeId)
        },
        validRemarks(){
            return (this.remarks.length > 0)
        },
        getEmployeeLeaveBalance() {
            return (userId) => {
                this.$store.dispatch('hrms/getAllLeaveBalance', userId)
                    .then( res => {
                       this.userLeaveBalance =  JSON.parse(JSON.stringify(res.data.data))
                    })
                    .catch(err => { console.error(err) })
            } 
        },
        checkLeaveBalance() {
        return (data) => {
            var leaveTypeId = data.leaveType.leaveTypeId
            var userId = data.userId
            var lt = this.leaveType(leaveTypeId)
            let leaveRequest = this.getEmployeeLeaveRequests
            var leavesTaken = 0

            leaveRequest.forEach(l => {
                if(l.leaveTypeId == leaveTypeId) {
                    if(this.onGetStatus(l) != 'Cancelled' && 
                    this.onGetStatus(l) != 'Retracted' &&
                    this.onGetStatus(l) != 'Denied')
                        leavesTaken += l.noOfDays
                }
            })
            this.getEmployeeLeaveBalance(userId)
            let leavesBalance = this.userLeaveBalance
            var leavesCredited = 0
            leavesBalance.forEach(l => {
                // if(l.leaveTypeId == leaveTypeId && leavesCredited <= lt.maxDays)
                if(l.leaveTypeId == leaveTypeId)
                    leavesCredited += l.leaveDays
            })
            if(leavesCredited > lt.maxDays)
              leavesCredited = leavesCredited - (leavesCredited - lt.maxDays)

            // this.leaveBalanceObjects.push(leavesCredited - leavesTaken)
            // console.log(this.leaveBalanceObjects)
            // this.leaveBalanceSeries = Object.entries(this.leaveBalanceObject)
            return leavesCredited - leavesTaken 
        }
           
      },
    },
    methods: {
        onApproved(filedLeaveId) {
            Swal.fire({
              title: 'Are you sure you want to <strong>continue</strong>?' ,
              text: "",
              icon: 'warning',
              customClass: {
                  icon: "no-before-icon",
              },
              showCancelButton: true,
              confirmButtonColor: '3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Approve'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$vs.loading()
                    const data = { 
                        employeeFiledLeaveId: filedLeaveId,
                        action: "APPROVED", 
                        isUnread : false, 
                        isApproved: true, 
                        approvedOn : this.getCurrentDate, 
                        isRetracted : false, 
                        approverId: this.$store.state.AppActiveUser.uid }
                    this.$store.dispatch('leavemanagement/onApproved', data)
                    .then((response) => { 
                        
                            this.$vs.loading.close()
                            if(response.status == 200)
                                this.$alert("You have successfully approved leave request.", "Approved Successfully", "success")
                            else
                                this.$alert("", response.statusText, "error")
                        })
                    .catch((error) => { 
                            this.$vs.loading.close()
                            this.$alert( error.message, "Error", "error")
                            })
                    } else
                        this.$alert("", 'Cancelled', "info")
            })
        },
        onDenied(filedLeaveId) {
             Swal.fire({
              title: 'Are you sure you want to <strong>continue</strong>?' ,
              text: "Note: You will not be able to revert this once you click the Deny button",
              input: 'text',
              inputPlaceholder:'Enter Remarks',
              icon: 'warning',
              customClass: {
                  icon: "no-before-icon",
              },
              showCancelButton: true,
              confirmButtonColor: '3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Deny',
              inputValidator: (value) => {
                    return new Promise((resolve) => {
                        if (value !== '') {
                            resolve()
                        } else {
                            resolve('Remarks is Required!')
                        }
                    })
              }
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$vs.loading()
                    this.remarks = result.value
                    const data = { 
                        employeeFiledLeaveId: filedLeaveId,
                        action: "DENIED", 
                        isUnread : false, 
                        isDenied: true, 
                        deniedOn : this.getCurrentDate, 
                        isRetracted : false, 
                        comments : this.remarks,
                        approverId: this.$store.state.AppActiveUser.uid
                    }
                    this.$store.dispatch('leavemanagement/onDenied', data)
                    .then((response) => { 
                            this.$vs.loading.close()
                            if(response.status == 200)
                                this.$alert("You have successfully denied leave request.", "Denied Successfully", "success")
                            else
                                this.$alert("", response.statusText, "error")
                        })
                    .catch((error) => { 
                            this.$vs.loading.close()
                            this.$alert( error.message, "Error", "error")
                        })
                 } else
                    this.$alert("", 'Cancelled', "info")
            }) 
            this.$vs.loading.close()
        },
        onForRevision(filedLeaveId) {
             Swal.fire({
              title: 'Are you sure you want to <strong>continue</strong>?' ,
            //   text: "You will not be able to revert this, but you can still use the same date unless denied or taken",
              input: 'text',
              inputPlaceholder:'Enter Remarks',
              icon: 'warning',
              customClass: {
                  icon: "no-before-icon",
              },
              showCancelButton: true,
              confirmButtonColor: '3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ask for revision',
               inputValidator: (value) => {
                    return new Promise((resolve) => {
                        if (value !== '') {
                            resolve()
                        } else {
                            resolve('Remarks is Required!')
                        }
                    })
              }
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$vs.loading()
                    this.remarks = result.value
                    const data = { 
                        employeeFiledLeaveId: filedLeaveId,
                        action: "REVISED", 
                        // isDraft: false,
                        // isSubmitted: false,
                        isUnread : false, 
                        isRevised: true, 
                        forRevisionOn : this.getCurrentDate, 
                        isRetracted : false, 
                        comments : this.remarks, 
                        approverId: this.$store.state.AppActiveUser.uid
                    }
                    this.$store.dispatch('leavemanagement/onRevised', data)
                    .then((response) => { 
                            this.$vs.loading.close()
                            if(response.status == 200)
                                this.$alert("You have successfully asked for leave request revision.", "Asking for Revision Successfully", "success")
                            else
                                this.$alert("", response.statusText, "error")
                        })
                    .catch((error) => { 
                            this.$vs.loading.close()
                            this.$alert( error.message, "Error", "error")
                    
                        })
                } else
                    this.$alert("", 'Cancelled', "info")

            })
            this.$vs.loading.close()
        },
        downloadFile(fileId){
            this.$store.dispatch('downloadFile', fileId)
                .then((response) => {
                    // console.log(response.headers['content-disposition'].split('filename="')[1].split('\";')[0])
                    let fileName = response.headers['content-disposition'].split('filename="')[1].split('\";')[0]
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName
                    // link.setAttribute('download', fileName )
                    // document.body.appendChild(link);
                    link.click();
                })
        },
        
        alertNotAllowed() {
            this.$alert('You are not allowed to do this at this time', 'Leave Request', 'warning')
        },
        
    }
    
}
</script>

